import React from 'react';
import { Image } from 'App';

const Project = React.createClass({
  componentDidMount() {
    window.scrollTo(0, 0);
  },

  rawContent() {
     return { __html: this.props.project.content };
  },

	render() {
    const project = this.props.project;

    return (
      <div>
        <h2>{ project.title }</h2>
        <div className="row">
          <Image featured_image={ project.featured_image } alt_text={ project.alt_text } />
        </div>
        <div dangerouslySetInnerHTML={ this.rawContent() } className="row"></div>
      </div>
    );
	}
});

export default Project;




// WEBPACK FOOTER //
// ./app/src/Portfolio/components/Project.js